/**
 * Deal settings groups into independent columns (#3664).
 *
 * A CSS grid row is as tall as its tallest card, so a short card leaves an
 * empty hole and the next card cannot rise into it. Dealing left, right,
 * left, right and stacking each column on its own closes that hole. A single
 * column keeps the canonical group order.
 */
export function packSettingsGroups<T>(items: readonly T[], columnCount: number): T[][] {
  if (items.length === 0) return [];
  const columns = Math.max(1, Math.floor(columnCount));
  if (columns === 1) return [[...items]];

  const packed: T[][] = Array.from({ length: columns }, () => []);
  items.forEach((item, index) => {
    packed[index % columns]?.push(item);
  });
  return packed.filter((column) => column.length > 0);
}
